/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { env } from '$env/dynamic/public';

export function getChannel(deviceType: string) {
    if (deviceType !== 'desktop') {
        return env.PUBLIC_MOBILE;
    } else {
        return env.PUBLIC_DESKTOP;
    }
}